module.exports = __webpack_public_path__ + "img/icon-store.74f32a00.svg";